import React, { useState } from "react";
import pajerobanner from "../assets/pajero.webp";
import "../style/Gravite.css";

import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Pajero = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    buyingTime: "",
    agree: false,
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      setPopupType("error");
      setPopupMessage("Please accept the marketing consent.");
      setShowPopup(true);
      return;
    }

    try {
      await addDoc(collection(db, "pajeroLeads"), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        state: formData.state,
        city: formData.city,
        buyingTime: formData.buyingTime,
        agree: formData.agree,
        offer: "Mitsubishi Pajero",
        createdAt: serverTimestamp(),
      });

      setPopupType("success");
      setPopupMessage(
        "Thank you! Your details have been submitted successfully."
      );
      setShowPopup(true);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        state: "",
        city: "",
        buyingTime: "",
        agree: false,
      });
    } catch (error) {
      console.error(error);

      setPopupType("error");
      setPopupMessage("Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  return (
    <div className="gravite-page">
      {/* HERO */}
      <div className="gravite-hero">
        <div className="hero-image">
          <img src={pajerobanner} alt="Mitsubishi Pajero" />
        </div>

        <form className="lead-form" onSubmit={handleSubmit}>
          <h2>Get Expert Advice Now</h2>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <label className="small-label">
            How soon are you looking to buy?
          </label>

          <select
            name="buyingTime"
            value={formData.buyingTime}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="Within 1 Month">Within 1 Month</option>
            <option value="1-3 Months">1-3 Months</option>
            <option value="3-6 Months">3-6 Months</option>
            <option value="6+ Months">6+ Months</option>
          </select>

          <div className="checkbox-row">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              By submitting this form, you agree that your data may be used for
              marketing purposes.
            </span>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>

      {/* ABOUT */}
 <section className="about-gravite">
        <h2>Experience the All-New Mitsubishi Pajero</h2>

        <p>
          The legendary Mitsubishi Pajero returns with a perfect balance of retro
          charm and modern sophistication. Built on a rugged ladder-frame chassis
          with a comfortable 7-seater layout, the new Pajero features a torquey
          2.4-litre diesel powertrain, 4WD capability, dual 14.3-inch screens,
          and a premium upmarket cabin designed for both daily commuting and serious off-roading.
        </p>
      </section>

      {/* TABLE */}
      <section className="tech-data">
        <h2>Technical Specifications of the Mitsubishi Pajero</h2>

        <table>
          <thead>
            <tr>
              <th>Specification</th>
              <th colSpan="4">Mitsubishi Pajero</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Engine</td>
              <td colSpan="4">2.4L Diesel</td>
            </tr>

            <tr>
              <td>Power</td>
              <td colSpan="4">TBA</td>
            </tr>

            <tr>
              <td>Torque</td>
              <td colSpan="4">480 Nm</td>
            </tr>

            <tr>
              <td>Transmission</td>
              <td colSpan="4">8-Speed Automatic (AT)</td>
            </tr>

            <tr>
              <td>Drivetrain</td>
              <td colSpan="4">4WD (Four-Wheel Drive)</td>
            </tr>

            <tr>
              <td>Ground Clearance</td>
              <td colSpan="4">230 mm</td>
            </tr>

            <tr>
              <td>Off-Road Capability</td>
              <td colSpan="4">Approach: 30.4° | Breakover: 22.6° | Departure: 25.8°</td>
            </tr>

            <tr>
              <td>Infotainment & Display</td>
              <td colSpan="4">Dual 14.3-inch Screens, Wireless Apple CarPlay & Android Auto</td>
            </tr>

            <tr>
              <td>Audio System</td>
              <td colSpan="4">12-Speaker Yamaha Sound System</td>
            </tr>

            <tr>
              <td>Safety</td>
              <td colSpan="4">
                8 Airbags, Level 2 ADAS, 360-Degree Camera, ESC, HHA, EPB
              </td>
            </tr>

            <tr>
              <td>Seating Capacity</td>
              <td colSpan="4">7-Seater Layout</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* CUSTOM POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div
              className={`popup-icon ${
                popupType === "success" ? "success" : "error"
              }`}
            >
              {popupType === "success" ? "✓" : "✕"}
            </div>

            <h3>
              {popupType === "success"
                ? "Submitted Successfully"
                : "Submission Failed"}
            </h3>

            <p>{popupMessage}</p>

            <button
              className="popup-btn"
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pajero;